import axios from "axios";
import ApiStore from "./ApiStore";

class QRstore extends ApiStore{
  constructor() {
    
    super();
  }

  getPrefixQR(){
    return 'http://2qr.co/b/'+this.SITE_APP
  }

  getReasonUrl(reason,value=''){
    return '?p=rs&v='+reason+'&v2='+value
  }

  getPauseUrl(value=''){
    return '?p=wp&v='+value
  }

  getStopUrl(value=''){
    return '?p=wst&v='+value
  }

  getLeaderOptionUrl(){
    return '?p=lo'
  }

  getLeaderCancelJobUrl(){
    return '?p=lc'
  }

  getLeaderEndJobUrl(){
    return '?p=le'
  }


  getPullJobUrl(){
    return '?p=pj'
  }

  getStartOptionUrl(value){
    return '?p=so&v='+value
  }


  getProfileImgURL(extEmployeeId, bfOrgId) {
    let baseURL = ''
    if (process.env.NODE_ENV === "development") {
      baseURL = 'https://api.bigfix.co/demo2'
    } else {
      let parts = window.location.hostname.split('.');
      let SITE_APP = parts.shift();
      baseURL = 'https://api.bigfix.co/' + SITE_APP;
    }
    return `${baseURL}/public/employee/photo_profile?ex_emp_id=${extEmployeeId}&bf_org_id=${bfOrgId}`
  }

  loadOption(completeFunc,errFunc){
    axios.get('/workdoc/worktracker/option')
      .then(response => {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(err => {
        console.log(err)
        if (errFunc) {
          errFunc(err)
        }
      })
  }

  loadEmployee(extEmployeeId, bfOrgId, completeFunc, errFunc) {
    axios.get(`/public/employee/info?ex_emp_id=${extEmployeeId}&bf_org_id=${bfOrgId}`)
      .then(response => {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(err => {
        console.log(err)
        if (errFunc) {
          errFunc(err)
        }
      })
  }

  loadCar(exWorkId, bfOrgId, employeeId,department,scanStatus, completeFunc, errFunc) {
    let url= `public/workdoc/info?ex_work_id=${exWorkId}&bf_org_id=${bfOrgId}&emp_id=${employeeId}&department=${department}&scan_status=${scanStatus}`
    console.log('loadCar',url)
    axios.get(url)
      .then(response => {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(err => {
        console.log(err)
        if (errFunc) {
          errFunc(err)
        }
      })
  }

  loadTaskList(wo, completeFunc, errFunc) {
    axios.get(`/public/workdoc/fixingtasklist?wo=${wo}`)
      .then(response => {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(err => {
        console.log(err)
        if (errFunc) {
          errFunc(err)
        }
      })
  }

  saveWorkdocFixingTask(taskId, postData, completeFunc, errorFunc) {
    console.log('fixingtask', taskId, postData)
    axios.post('/workdoc/fixingtask/' + taskId, postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  saveTimeRecord(action,workNo,employeeId,department,value,completeFunc,errorFunc){
    axios.post('/workdoc/timerecord/'+action+'?wo=' + workNo+'&em='+employeeId, {work_no:workNo,employee_id:employeeId,department:department,task_state:value})
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  savePauseReason(workNo,employeeId,department,reasonCode,reason,taskState,completeFunc,errorFunc){
    axios.post('/workdoc/timerecord/pause'+'?wo=' + workNo+'&em='+employeeId+'&reason_code='+reasonCode, 
    {work_no:workNo,employee_id:employeeId,department:department,reason_code:reasonCode,reason:reason,task_state:taskState})
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  savePullJob(employeeId,department,jobList,completeFunc,errorFunc){
    axios.post('/workdoc/pulljob/'+'?&em='+employeeId, {employee_id:employeeId,department:department,joblist:jobList})
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status == 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log(error);
        errorFunc({ status: 'error', desc: error });
      })
  }
}

export default new QRstore()


// WEBPACK FOOTER //
// ./src/stores/QRstore.js